<template>
  <!-- Active Users Card -->
  <a-row :gutter="24">
    <a-col :span="12" :lg="12" class="mb-24" style="padding: 0">
      <a-card :bordered="false" class="dashboard-bar-chart" style="width: 100%">
        <div class="title_box">
          <div>微信教程</div>
          <div class="title_link" @click="downloadVideo(1)">下载视频</div>
        </div>
        <div v-if="!wxPlayShow" class="img_box">
          <img
            class="bofang_img"
            @click="wxPlay"
            src="@/assets/bofang.png"
            alt=""
          />
          <img style="height: 600px" :src="wxImg" alt="" />
        </div>
        <video
          v-show="wxPlayShow"
          ref="videoPlayer"
          height="600px"
          controls
          style="border-radius: 10px"
          :src="wxMp4"
        ></video>
      </a-card>
    </a-col>
    <a-col :span="12" :lg="12" class="mb-24">
      <a-card :bordered="false" class="dashboard-bar-chart">
        <div class="title_box">
          <div>支付宝教程</div>
          <div class="title_link" @click="downloadVideo(2)">下载视频</div>
        </div>
        <div v-if="!aliPlayShow" class="img_box">
          <img
            class="bofang_img"
            @click="aliPlay"
            src="@/assets/bofang.png"
            alt=""
          />
          <img style="height: 600px" :src="zfbImg" alt="" />
        </div>
        <video
          v-show="aliPlayShow"
          ref="aliVideoPlayer"
          height="600px"
          controls
          style="border-radius: 10px"
          :src="zfbMp4"
        ></video>
      </a-card>
    </a-col>
  </a-row>

  <!-- Active Users Card -->
</template>

<script>
// Bar chart for "Active Users" card.

export default {
  data() {
    return {
      wxPlayShow: false,
      aliPlayShow: false,
      wxImg: "https://rp-img.1japp.com/mp4/wx1.jpg",
      zfbImg: "https://rp-img.1japp.com/mp4/zfb1.jpg",
      wxMp4: "https://rp-img.1japp.com/mp4/wxf100800.mp4",
      zfbMp4: "https://rp-img.1japp.com/mp4/zfbf100800.mp4",
    };
  },
  methods: {
    wxPlay() {
      this.wxPlayShow = true;
      const video = this.$refs.videoPlayer;
      video.play(); // 自动播放视频
    },
    aliPlay() {
      this.aliPlayShow = true;
      const video = this.$refs.aliVideoPlayer;
      video.play(); // 自动播放视频
    },
    downloadVideo(type) {
      let url = type == 1 ? this.wxMp4 : this.zfbMp4;
      let filename = type == 1 ? "wx.mp4" : "zfb.mp4";
      fetch(url)
        .then((response) => response.blob()) // 将视频文件转为 Blob 对象
        .then((blob) => {
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob); // 创建一个临时的 URL
          link.download = filename || url.split("/").pop(); // 设置下载文件名
          document.body.appendChild(link);
          link.click(); // 触发下载
          document.body.removeChild(link); // 清理 DOM
        })
        .catch((error) => {
          console.error("下载失败:", error);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.title_box {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px 10px 10px;
  font-weight: 700;
  font-size: 20px;
  margin-left: 0px;
  width: 100%;
  &::after {
    position: absolute;
    left: 0;
    content: "";
    width: 5px;
    height: 20px;
    background: #2a82e4;
  }
  .title_link {
    color: #1890ff;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
  }
}
.img_box {
  position: relative;
  .bofang_img {
    position: absolute;
    top: calc(50% - 50px);
    left: calc(50% - 50px);
    height: 100px;
    cursor: pointer;
  }
}
</style>
<style lang="scss">
.dashboard-bar-chart {
  display: flex;
  align-items: flex-start;
  // justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  padding: 0;
  .ant-card-body {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    width: 100% !important;
  }
}
</style>
